<template>
  <div>
    <div
      class="FloorSecond"
      :style="{ backgroundImage: 'url(' + backImg + ')' }"
    >
      <div class="title_box">
        <div class="en">DIVERSIFIED APPLICATION SCENARIOS</div>
        <div class="zh">多元化应用场景</div>
        <div class="line"></div>
      </div>
      <div class="carousel_box">
        <el-carousel
          :interval="4000"
          type="card"
          height="25.72vw"
          indicator-position="none"
          arrow="never"
          :autoplay="false"
          @change="changeSlide"
          v-if="arr.length"
        >
          <el-carousel-item v-for="(item, index) in arr" :key="index">
            <el-image
              :src="item.image"
              style="height: 100%;width:100%;"
              fit="fit"
              @click="preview(index)"
            ></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="name_box" v-if="arr.length">
        <div class="zh">{{ arr[active].name }}</div>
        <div class="en">{{ arr[active].en }}</div>
        <div class="line"></div>
      </div>
      <div class="preview_box" @click="close" v-if="previewflag && arr.length">
        <div class="preview_center" @click.stop>
          <el-image
            :src="arr[active].image"
            style="height: 100%; width: 100%"
            fit="fit"
          ></el-image>
          <div class="bottom_text">{{ arr[active].name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "",
  props: {
    obj: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      active: 0,
      previewflag: false,
      arr: [
        {
          zh: "公共场所及花园农业灌溉系统1",
          en: "Agricultural irrigation system for public places and gardens",
          img: require("../../assets/components_img/temporary/tianyuan_three_img.png"),
        },
        {
          zh: "公共场所及花园农业灌溉系统2",
          en: "Agricultural irrigation system for public places and gardens",
          img: require("../../assets/components_img/temporary/tianyuan_three_img.png"),
        },
        {
          zh: "公共场所及花园农业灌溉系统3",
          en: "Agricultural irrigation system for public places and gardens",
          img: require("../../assets/components_img/temporary/tianyuan_three_img.png"),
        },
      ],
      changSlid: "",
      backImg: "",
    };
  },
  mounted() {
    // this.$nextTick(function () {
    //   $(
    //     ".FloorSecond .carousel_box .el-carousel .el-carousel__container .is-active"
    //   ).css({
    //     width: "988px",
    //     transform: "translateX(280px) scale(1)",
    //   });
    // });
  },
  methods: {
    changeSlide(val) {
      this.changSlid = val;
      this.active = val;
      // this.$nextTick(function () {
      //   $(
      //     ".FloorSecond .carousel_box .el-carousel .el-carousel__container .is-active"
      //   ).css({
      //     width: "988px",
      //     transform: "translateX(280px) scale(1)",
      //   });
      // });
    },
    preview(e) {
      if (this.changSlid == e) {
        this.active = e;
        this.previewflag = true;
      }
    },
    close() {
      this.previewflag = false;
    },
  },
  watch: {
    obj(val) {
      if (val.cate_id) {
        this.backImg = val.scene_background; ///背景未返回
        this.arr = val.scene_image;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.FloorSecond {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  background-size: cover;
  position: relative;
 .title_box {
    width: 100vw;
    height: 9.3vh;
    padding-top: 16vh;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      text-align: center;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 5.8vh;
      line-height: 58px;
      color: #ffffff;
      text-align: center;
      width: 100%;
      margin-top: -22px;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .carousel_box {
    margin: 0 auto;
    // width: 1520px;
    width: 79.16vw;
    min-width: 1200px;
    // height: 494px;
    height: 25.72vw;
    margin-top: 40px;
    // margin-top: 4vh;
  }
  .name_box {
    text-align: center;
    // border-end-end-radius: 50%;
    // border-start-start-radius: 50%;
    // width: 760px;
    //width: 39.58vw;
    //margin: 0 auto;
    // margin-top: 20px;
    margin: 40px auto 0;
    .zh {
      width: 100%;
      margin: 0 auto;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 4vh;
      color: #ffffff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .en {
      width: 100%;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 1.9vh;
      color: #ffffff;
      margin: 10px auto;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .line {
      width: 40px;
      height: 2px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .preview_box {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
    display: flex;
    justify-content: center;
    // align-items: center;
    .preview_center {
      width: 1200px;
      // height: 600px;
      height: 60vh;
      position: relative;
      // margin-top: 150px;
      margin-top: 15vh;
      .bottom_text {
        position: absolute;
        bottom: 0;
        // height: 80px;
        height: 8vh;
        width: 100%;
        background: rgba(26, 26, 26, 0.6);
        text-align: center;
        line-height: 8vh;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>